import { render, staticRenderFns } from "./VueSelectTempUniversity.vue?vue&type=template&id=7695f8da&scoped=true&"
import script from "./VueSelectTempUniversity.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempUniversity.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempUniversity.vue?vue&type=style&index=0&id=7695f8da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695f8da",
  null
  
)

export default component.exports